export const RoutesLink = {
  Login: '/',
  forgetPassword: 'forget-password',
  dashboard: '/dashboard',
  products: '/products',
  productDetail: '/product-detail',
  productManager: '/product-manager',
  addProducts: '/edit-product',
  variants: '/variants',
  addCategory: '/add-category',
  categoryList: '/categories',
  categoryManager: '/category-manager',
  addBrands: '/add-brands',
  brandsList: '/brands',
  brandManager: '/brands-manager',
  order: '/orders',
  orderDetail: '/order-detail',
  refundReturn: '/refund-return',
  refundDetail: '/refund-detail',
  abandonedCheckouts: '/abandoned-checkouts',
  customer: '/customer',
  customerDetails: '/customer-details',
  addDriver: '/add-driver',
  reviewRating: '/review-rating',
  reviewRatingDetails: '/review-rating-details',
  discounts: '/discounts',
  addDiscount: '/add-discount',
  addCoupon: '/add-coupon',
  coupons: '/coupons',
  addSpinWheel: '/add-spin-wheel',
  spinWheels: '/spin-wheels',
  collection: '/collection',
  collectionDetails: '/collection-detail',
  createCollection: '/create-collection',
  empDiscount: '/emp-discount',
  createEmpDiscount: '/create-emp-discount',
  staffs: '/staffs',
  reports: '/reports',
  websiteContent: '/website-content',
  addContent: '/add-content',
  roles: '/roles',
  addRoles: '/add-role',
  viewRole: '/view-role',
  addStaff: '/add-staff',
  refundReason: '/refund-reasons',
  privacyPolicy: '/privacy-policy',
  termsCondation: '/terms-and-condation',
  notifications: '/notification',
  sendNotification: '/send-notification',
  appLayout: '/app-layout',
} as const;
